import { reactive, readonly} from "vue";

const state = reactive({
  isActive:false
})

export default {
  isActive:readonly(state.isActive),
  }
